import React from "react";
import { MARKETING_URL, PRIVACY_URL, TOS_URL } from "./constants";

const MarketingFooter = () => (
  <>
    <p className="signin-legal">
      For more info about iKizmet
      <br />
      <a className="no-decoration" target="_blank" rel="noreferrer" href={MARKETING_URL}>
        Visit Our Marketing Site
      </a>
    </p>
    <p className="signin-legal">
      By using this site you agree to the
      <br />
      <a className="no-decoration" target="_blank" rel="noreferrer" href={PRIVACY_URL}>
        Privacy Policy
      </a>{" "}
      and{" "}
      <a className="no-decoration" target="_blank" rel="noreferrer" href={TOS_URL}>
        Terms of Service
      </a>
    </p>
  </>
);

export default MarketingFooter;
